// TODO: Ask Jeremy to review these vs colour palette, and give semantic names
// See https://www.figma.com/design/uDql1qJTNBIvGnFDsOpWV4/ESG360-AIR?node-id=1-3&p=f&t=VW3LD4CJoLI9sBcf-0
export const colors = {
  // Theme V1 Colors
  esg_gray: {
    100: "#EDF2F7", // was: "#EAEDF3",
    200: "#A4A8B4",
    300: "#9EA0A5",
    400: "#8E8E8E",
  },
  esg_black: "#000000",
  esg_white: "#FFFFFF",
  esg_lightgreen: "#2D6876",
  esg_green: "#6EA161",
  esg_blue: "#3182CE",
  esg_orange: "#DD6B20",
  esg_decarb: "#df7519",
  esg_red: "#F07065",
  esg_link: "#2DC76D",
  esg_overlay: "rgba(59,59,59,0.76)",
  sidebar_background: "#F7FAFC", // TODO "#F7F9FA", post-demo, as non-white can make any layout spacing gaps look bad
  esg_teal: "#466065",
  esg_sub_active: "#DBF9F0",
  esg_active: "#B2F1DE",
  esg_label_color: "#0A181A",
  layout_background: "#FFFFFF",
  customScheme: {
    500: "#1A3C44",
    600: "#4D747F",
  },
  subtitle_label: "#2D3748",

  // Theme V2 Colors
  // brand colors
  teal: "#0C3136",
  darkTeal: "#051F23",
  // lime: "#A6F334", // This isn't quite the same as any of the limeShades
  lightGreen: "#E1FDE4",

  lime: "#85C22A",

  lightLime: "#F2FDE1",
  pureWhite: "#FFFFFF",
  pureBlack: "#000000",

  headingGrey: "#767676",
  borderGrey: "#E0E0E0",

  // lime tints
  limeTint: {
    50: "#F7FFE5",
    100: "#ECFFC8",
    200: "#D8FF97",
    300: "#BDFC5A",
    // 900: "#345710",
    // 950: "#193102"
  },

  // to review below
  limeShade: {
    50: "#F7FFE5",
    100: "#ECFFC8",
    200: "#D8FF97",
    300: "#BDFC5A",
    500: "#82D909",
    600: "#63AD03",
    700: "#4B8407",
    800: "#3E680C",
    900: "#345710",
    950: "#193102",
  },

  green: {
    800: "#22543D",
  },

  // Used by eg AdditionalStatusField
  status: {
    red: "#FC2B18",
    orange: "#FFD008",
    green: "#25C469",
    lightGreen: "#82D909",
    pink: "#FDE1FD",
  },

  // DEPRECATED - use esg_gray for grays
  whiteShade: {
    300: "#CBD5E0", // keep this off-white, but use esg_gray for others
    500: "#718096",
    600: "#4A5568",
    700: "#2D3748",
    // 400: "#A0AEC0",
  },

  //   tag: { // removed as the only use was for stageType -- which is defined below
  //     progress: "#E1FBFD",
  //     approval: "#EAE1FD",
  //   },

  // AI Data Mapping Commit page (design handoff, ESG-4007-follow-up): the "Replace" (destructive) and
  // "Add"/success card washes. Distinct from `esg_orange`/`status.orange` and from Chakra's default
  // orange/green palettes — named here once rather than as ad-hoc hex literals through CommitPanel.jsx.
  destructive: {
    bg: "#FFF5EB",
    border: "#F8D9B5",
    text: "#C4620A",
    textDark: "#8A4508",
  },
  successCard: {
    bg: "#F4F8EE",
    border: "#DDEBCB",
  },
};

/** Matches enum WorkflowStageType.java
 * Note: the stage names are a bit different e.g. "In Preparation" vs "START"
 */
colors.stages = {
  START: "#FFD008", // aka preparation
  AI_QUEUE: "#FA5B4D", // queued
  EXPERT_REVIEW: "#25C469", // aka review
  PENDING: "#EDF2F7",
  IN_PROGRESS: "#5EB5F3", // inProgress
  INTERNAL_REVIEW: "#9A34F3", // readyForApproval
  AUDIT: "#FDE1FD", // aka readyForAudit
  EXCLUDED: "#000000",
  EXCLUDED_BY_RULE: "#000000",
  COMPLETE: "#82D909",
};
/** Faded versions of the stage colors, for use in backgrounds */
colors.stagesFaded = {
  START: "rgba(255, 208, 8, 0.25)",
  AI_QUEUE: "rgba(250, 91, 77, 0.25)",
  EXPERT_REVIEW: "rgba(37, 196, 105, 0.25)",
  PENDING: "rgba(237, 242, 247, 0.25)",
  IN_PROGRESS: "rgba(94, 181, 243, 0.25)",
  INTERNAL_REVIEW: "rgba(154, 52, 243, 0.25)",
  AUDIT: "rgba(253, 225, 253, 0.25)",
  EXCLUDED: "rgba(0, 0, 0, 0.25)",
  EXCLUDED_BY_RULE: "rgba(0, 0, 0, 0.25)",
  COMPLETE: "rgba(130, 217, 9, 0.25)",
};

colors.highMediumLow = {
  HIGH: colors.status.green,
  MEDIUM: colors.status.orange,
  LOW: colors.status.red,
  NONE: colors.esg_gray[300],
};

/**
 * Colors for the status of an AI task
 */
colors.aiTaskStatus = {
  draft: "gray",
  queued: "gray",
  running: colors.stages.IN_PROGRESS,
  done: colors.stages.EXPERT_REVIEW,
  failed: colors.status.red,
  cancelled: colors.status.orange,
};

colors.pageHeader = colors.darkTeal;
colors.headingLime = colors.limeShade[600];
colors.navIconLime = colors.limeShade[500];

// Make text inputs visible on lower-contrast monitors
document.documentElement.style.setProperty("--chakra-colors-chakra-border-color", colors.esg_gray[300]);
// TODO textarea too
